import Timesheet from "../common/Timesheet";

const EmployeeTimesheet = () => <Timesheet />;

export default EmployeeTimesheet;
